import { AdminEmployerProfileBusinessType, AdminEmployerProfileIndustry, AdminEmployerReviewStatus } from './web_api.schemas'

export function getIndustryDisplayText (industry?: AdminEmployerProfileIndustry): string | undefined {
  if (!industry) return industry

  switch (industry) {
    case AdminEmployerProfileIndustry.accommodation_and_food_services:
      return 'Accommodation & Food Services'
    case AdminEmployerProfileIndustry.administrative_and_support_and_waste_management_services:
      return 'Administrative & Support Services'
    case AdminEmployerProfileIndustry.agriculture_forestry_fishing_and_hunting:
      return 'Agriculture, Forestry & Fishing'
    case AdminEmployerProfileIndustry.arts_entertainment_and_recreation:
      return 'Arts, Entertainment & Recreation'
    case AdminEmployerProfileIndustry.construction:
      return 'Construction'
    case AdminEmployerProfileIndustry.educational_services:
      return 'Educational Services'
    case AdminEmployerProfileIndustry.finance_and_insurance:
      return 'Finance & Insurance'
    case AdminEmployerProfileIndustry.health_care_and_social_assistance:
      return 'Healthcare & Social Assistance'
    case AdminEmployerProfileIndustry.information_and_technology:
      return 'Information & Technology'
    case AdminEmployerProfileIndustry.management_of_companies_and_enterprises:
      return 'Management of Companies'
    case AdminEmployerProfileIndustry.manufacturing:
      return 'Manufacturing'
    case AdminEmployerProfileIndustry.mining_quarrying_and_oil_and_gas_extraction:
      return 'Mining & Extraction'
    case AdminEmployerProfileIndustry.other_services_except_public_administration:
      return 'Other Services'
    case AdminEmployerProfileIndustry.professional_scientific_and_technical_services:
      return 'Professional & Technical Services'
    case AdminEmployerProfileIndustry.public_administration:
      return 'Public Administration'
    case AdminEmployerProfileIndustry.real_estate_and_rental_and_leasing:
      return 'Real Estate & Leasing'
    case AdminEmployerProfileIndustry.retail_trade:
      return 'Retail Trade'
    case AdminEmployerProfileIndustry.transportation_and_warehousing:
      return 'Transportation & Warehousing'
    case AdminEmployerProfileIndustry.utilities:
      return 'Utilities'
    case AdminEmployerProfileIndustry.wholesale_trade:
      return 'Wholesale Trade'
    case AdminEmployerProfileIndustry.other:
      return 'Other'
    default:
      return industry
  }
}

export function getBusinessTypeDisplayText (businessType?: AdminEmployerProfileBusinessType): string {
  if (!businessType) return 'Unknown Business Type'

  switch (businessType) {
    case AdminEmployerProfileBusinessType.c_corp:
      return 'C Corp'
    case AdminEmployerProfileBusinessType.s_corp:
      return 'S Corp'
    case AdminEmployerProfileBusinessType.llc:
      return 'LLC'
    case AdminEmployerProfileBusinessType.llp:
      return 'LLP'
    case AdminEmployerProfileBusinessType.partnership:
      return 'Partnership'
    case AdminEmployerProfileBusinessType.sole_proprietorship:
      return 'Sole Proprietorship'
    case AdminEmployerProfileBusinessType.non_profit:
      return 'Non-Profit'
    default:
      return businessType
  }
}

export function getReviewStatusDisplayText (reviewStatus?: AdminEmployerReviewStatus): string {
  if (!reviewStatus) return 'Unknown Review Status'

  switch (reviewStatus) {
    case AdminEmployerReviewStatus.pending:
      return 'Pending Review'
    case AdminEmployerReviewStatus.approved:
      return 'Approved'
    case AdminEmployerReviewStatus.denied:
      return 'Denied'
    case AdminEmployerReviewStatus.inactive_duplicate:
      return 'Inactive - Duplicate'
    case AdminEmployerReviewStatus.inactive_withdrawn:
      return 'Inactive - Withdrawn'
    case AdminEmployerReviewStatus.inactive_ineligible:
      return 'Inactive - Ineligible'
    case AdminEmployerReviewStatus.inactive_churned:
      return 'Inactive - Churned'
    default:
      return reviewStatus
  }
}
